import * as React from "react";
import { Chart, ChartArea, ChartSeries, ChartSeriesItem, ChartCategoryAxis, ChartCategoryAxisItem, ChartValueAxis, ChartValueAxisItem } from "@progress/kendo-react-charts";
import moment from 'moment';
import { sbaAxios } from "../utils/sbaAxios";
import { getMgmtSummary } from "../../config/apiConfig";
import { useEffect } from "react";
import { useState } from "react";
import { WidgetCollectionContext } from "./home";
import { useContext } from "react";
import CloseSVG from "../../Images/close_svg.svg";



const AumChart = () => {
  const { removeWidget, toCustomize } = useContext(WidgetCollectionContext);
  const [data,setData]=useState([]);
  const [aumSelectedButton, setAumButton] = useState(0);
  useEffect(()=>{
    fetchMgmtSummary(0);
  },[]);
  const sortedData = [...data].sort((a, b) => new Date(a.ValuationDate) - new Date(b.ValuationDate));
  const groupSize = sortedData.length === 36 ? 3 : (sortedData.length === 60 ? 6 : 1)
  const aggregatedData = [];
  for (let i = 0; i < sortedData.length; i += groupSize) {
    const group = sortedData.slice(i, i + groupSize);
    const startLabel = moment(group[0].ValuationDate).format("MMM YY");
    const endLabel = moment(group[group.length - 1].ValuationDate).format("MMM YY");
    const aggregatedTotalAUM = group.reduce((sum, item) => sum + item.totalAUM, 0);
    const aggregatedAdvisedAUM = group.reduce((sum, item) => sum + item.advisedAUM, 0);
    aggregatedData.push({
      label: groupSize === 1 ? `${startLabel}` : `${startLabel} - ${endLabel}`,
      totalAUM: aggregatedTotalAUM,
      advisedAUM: aggregatedAdvisedAUM,
    });
  }
  const categories = aggregatedData.map((item) => item.label);
  const totalAUMData = aggregatedData.map((item) => ({ value: item.totalAUM }));
  const advisedAUMData = aggregatedData.map((item) => ({ value: item.advisedAUM }));
  const benchmarkingPerfButtonNames = ['YTD', '1Y', '3Y', '5Y'];
  const fetchMgmtSummary = async (aumSelectedButton) => {
    try {
      const list = await sbaAxios({
        url: getMgmtSummary,
        params: {
          enumerate: aumSelectedButton
        }
      });
      setData(list);
    }
    catch (e) {
      setData([]);
    }
  };
  const aumButtonClick = (index) => {
    setAumButton(index);
    fetchMgmtSummary(index);
  };
  return (
    <div className="k-tilelayout-item k-card k-cursor-grab h-100">
    <div className="k-tilelayout-item-header k-card-header">
        <div className="header-container">
          <b>AUM</b>
          <div className="button-container ms-auto">
            {benchmarkingPerfButtonNames.map((name, index) => (
              <button
                key={index}
                className={aumSelectedButton === index ? "selected-non-gappable-button p-2" : "non gappable-button p-2"}
                onClick={() => aumButtonClick(index)}
              >
                {name}
              </button>
            ))}
          </div>
          {toCustomize && <a className="" href="#" onClick={() => {
          removeWidget(3)
        }}>
          <img src={CloseSVG}
            alt="close" />
    </a>}


        </div>
      </div>
      <div className="k-tilelayout-item-body k-card-body">
      <Chart style={{ height: "100%" }}>
      <ChartCategoryAxis>
        <ChartCategoryAxisItem
          categories={categories}
          labels={{
            rotation: 45, // Rotate labels for better visibility
            step: 1,      // Show every label
          }}
        />
      </ChartCategoryAxis>

      <ChartValueAxis>
        <ChartValueAxisItem
          name="primary"
          color="#7D7D7D"
          labels={{ step: 5, format:"c0"}}
        />
      </ChartValueAxis>

      <ChartArea background={"white"} />

      <ChartSeries>
        
        <ChartSeriesItem
          type="column"
          data={advisedAUMData}
          field="value"
          color="#05BFDB"
          markers={{ visible: false }}
          tooltip={{ visible: true, format:"c2" }}
          axis="primary"
          name="Advised AUM"
        />
        <ChartSeriesItem
          type="column"
          data={totalAUMData}
          field="value"
          color="#FF8686"
          markers={{ visible: false }}
          tooltip={{ visible: true, format:"c2" }}
          axis="primary"
          name="Total AUM"
        />
      </ChartSeries>
    </Chart>
      </div>
     
    
    </div>
   
  );
};
export default AumChart;